(function () {
  'use strict';

  angular.module('showcaseApp')
    .controller('BrandFlyerListController', BrandFlyerListController);

  /** @ngInject */
  function BrandFlyerListController($scope, RemoveModalFactory, CategoryFlyerService, toastr, $translate, $state, BrandService, $localStorage, $uibModal) {
    var vm = this;

    vm.brands = [];
    vm.loadingList = false;
    vm.isImmoContext = $localStorage.defaultStore.immoContext;
    vm.isHubContext = $localStorage.defaultStore.hubContext;
    vm.brandFilter = { "id": "", "name": "" };

    vm.currentPage = 1;
    vm.numPerPage = 40;
    vm.totalBrands = 0;
    vm.startRegistry = 1;
    vm.endRegistry = 40;
    vm.maxSize = 5;

    vm.init = init;
    vm.$onInit = init;

      function init() {
          if (vm.isImmoContext && !vm.isHubContext) {
              $state.go('accessdenied');
          }
          vm.brandFilter = { "id": "", "name": ""  };
          vm.brandData = { name: '', logo: null };

          vm.filterChange();
      }

      vm.filterChange = function () {
          vm.currentPage = 1;
          vm.changePage();
      }

      vm.changePage = function () {
          vm.loadingList = true;
          loadBrandList().then(function (result) {
              var page = result.data;
              vm.brands = page.content;
              vm.totalBrands = page.totalElements;

              var begin = ((vm.currentPage - 1) * vm.numPerPage),
                  end = begin + vm.numPerPage;

              vm.startRegistry = begin + 1;
              vm.endRegistry = Math.min(end, vm.totalBrands);
              vm.loadingList = false;

          }, function () {
              vm.loadingList = false;
          });
      };

      vm.showModalBrand = function() {
          return $uibModal.open({
              templateUrl: "app/admin/brand/modal-brand.html",
              windowClass: 'modal-side-menu',
              size: 'md',
              controller: "ModalBrandController",
              controllerAs: "vm",
              backdrop: 'static',
              resolve: {
                  brand: function () {
                  },
                  onFlyerForm: function () {
                      return false;
                  },
              }
          }).result.then(function() {
              vm.init();
          });
      };

      vm.getTranslateKey = function (baseKey) {
          return getTranslateKey(vm.isImmoContext, baseKey)
      };

      function loadBrandList() {
          const pageToSend = vm.currentPage - 1;

          return BrandService.findBrand(
              vm.brandFilter.name || "",
              pageToSend,
              vm.numPerPage
          );
      }
  }

}());
